import React, { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import { useAuth } from '../context/AuthContext';

const LockdownGuard = ({ children }) => {
  const { user, isAuthenticated, loading: authLoading } = useAuth();
  const location = useLocation();
  const [lockdownActive, setLockdownEnabled] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkLockdown = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/system/settings`);
        if (res.data?.success && res.data?.data?.lockdown?.enabled) {
          setLockdownEnabled(true);
        }
      } catch (err) {
        console.error('LockdownGuard: Error checking status', err);
      } finally {
        setChecking(false);
      }
    };

    checkLockdown();
  }, []);

  if (checking || authLoading) {
    return (
      <div className="min-h-screen bg-dark-950 text-white flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-primary/15 border border-primary/25 flex items-center justify-center">
            <div className="w-5 h-5 rounded-full border-2 border-primary/30 border-t-[#C0F050] animate-spin" />
          </div>
          <div className="text-sm text-dark-400">Loading…</div>
        </div>
      </div>
    );
  }

  // If lockdown is not active, allow everything
  if (!lockdownActive) {
    return children;
  }

  // Paths that are ALWAYS allowed even in lockdown
  const exemptPathPrefixes = [
    '/lockdown-access',
    '/login',
    '/register',
    '/about',
    '/terms',
    '/privacy',
    '/exclusive-access',
    '/hiring/apply',
    '/careers'
  ];
  const isExempt = exemptPathPrefixes.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`));
  if (isExempt) {
    return children;
  }

  // If user is logged in, do not force-redirect here.
  // Backend will enforce whitelist/admin rules and return 503 when blocked.
  if (isAuthenticated && user) {
    return children;
  }

  // Otherwise (not authenticated), redirect to lockdown access page
  return <Navigate to="/lockdown-access" replace />;
};

export default LockdownGuard;
